import { useForm, FormProvider } from "react-hook-form";
import SelectDropdown from "../features/header/SelectDropdowns";
import { apps } from "./Constants";

interface FeedbackFilterFormProps {
  selectedFeedback: { label: string; value: string };
  setSelectedFeedback: (option: { label: string; value: string }) => void;
}

export default function FeedbackFilterForm({
  selectedFeedback,
  setSelectedFeedback,
}: FeedbackFilterFormProps) {
  const methods = useForm();

  return (
    <FormProvider {...methods}>
      <form className="w-full">
        <SelectDropdown
          label="Filter App"
          name="filterApp"
          options={apps}
          defaultValue={selectedFeedback.label} 
          onChange={(value: string) => {
            const found = apps.find((option) => option.value === value);
            if (found) {
              setSelectedFeedback(found);
            }
          }}
          placeHolder="Choose an app..."
          isAgent={true}
        />
      </form>
    </FormProvider>
  );
}
